import { Icon as ChakraIcon, useStyleConfig, IconProps as ChakraIconProps } from '@chakra-ui/react';
import { FaQuestion } from 'react-icons/fa';
import { IconType } from 'react-icons/lib';
import { ComponentStyleConfig } from '@chakra-ui/theme';

type IconProps = ChakraIconProps & {
  as?: IconType;
  size?: 'sm' | 'md' | 'lg';
};

const IconStyles: ComponentStyleConfig = {
  sizes: {
    sm: {
      fontSize: 'md',
    },
    md: {
      fontSize: 'xl',
    },
    lg: {
      fontSize: '4xl',
    },
  },
};

const Icon = ({ size = 'md', as = FaQuestion, ...props }: IconProps) => {
  const styles = useStyleConfig('Icon', { size });

  return <ChakraIcon __css={styles} as={as} {...props} />;
};

export { Icon, IconStyles };
